/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type RotateLiteLLMInstanceKeySecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type RotateLiteLLMInstanceKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type RotateLiteLLMInstanceKeySecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RotateLiteLLMInstanceKeySecurity$outboundSchema: z.ZodMiniType<
  RotateLiteLLMInstanceKeySecurity$Outbound,
  RotateLiteLLMInstanceKeySecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function rotateLiteLLMInstanceKeySecurityToJSON(
  rotateLiteLLMInstanceKeySecurity: RotateLiteLLMInstanceKeySecurity,
): string {
  return JSON.stringify(
    RotateLiteLLMInstanceKeySecurity$outboundSchema.parse(
      rotateLiteLLMInstanceKeySecurity,
    ),
  );
}

/** @internal */
export type RotateLiteLLMInstanceKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const RotateLiteLLMInstanceKeyRequest$outboundSchema: z.ZodMiniType<
  RotateLiteLLMInstanceKeyRequest$Outbound,
  RotateLiteLLMInstanceKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    riskIDRequestBody: RiskIDRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      riskIDRequestBody: "RiskIDRequestBody",
    });
  }),
);

export function rotateLiteLLMInstanceKeyRequestToJSON(
  rotateLiteLLMInstanceKeyRequest: RotateLiteLLMInstanceKeyRequest,
): string {
  return JSON.stringify(
    RotateLiteLLMInstanceKeyRequest$outboundSchema.parse(
      rotateLiteLLMInstanceKeyRequest,
    ),
  );
}
